import {
    TypedUseSelectorHook, useDispatch, useSelector,
} from 'react-redux';

import {TAppState, TDispatch} from './types';

export const useAppDispatch = (): TDispatch => useDispatch<TDispatch>();
export const useAppSelector: TypedUseSelectorHook<TAppState> = useSelector;
